import { memo, VFC, useEffect, useState } from 'react';
import {
  Modal,ModalOverlay,ModalContent,ModalFooter,ModalBody,ModalCloseButton,
  useDisclosure,
} from '@chakra-ui/react';
// import { useLoginUser } from '../../../hooks/providers/useLoginUserProvider';
import { PrimaryButton } from '../../atoms/button/PrimaryButton';
import { IssueDetailBase } from '../../organisms/base/IssueDetailBase';
import { useIssue } from '../../../hooks/useIssue';
import { ErrorDialog } from '../../organisms/modal/ErrorDialog';
import { useOpelog } from '../../../hooks/useOpelog';
import { GV_DIALOG_SIZE } from '../../../hooks/useConst';

type Props = {
  issueArn: string;
  setIssueArn: (issueArn:string) => void;
  direct? : boolean;
};

export const IssueDetailDialog: VFC<Props> = memo((props) => {
  const { issueArn, setIssueArn, direct=false } = props;
  const { isOpen, onOpen } = useDisclosure();
  
  const { issueDetailObj, executing, errObj, getIssueDetail } = useIssue();
  const [ execFlag, setExecFlag ] = useState(false);
  // const { loginUser } = useLoginUser();
  const { OutputOpelog } = useOpelog();
  const [ closeFlag, setCloseFlag ] = useState(false);
  
  // 初期実行
  useEffect(() => {
    !isOpen && onOpen();
    setExecFlag(true);
    // eslint-disable-next-line
  }, []);
    
  useEffect(() => {
    if( issueArn && execFlag ){
      setExecFlag(false);
      getIssueDetail(issueArn);
      
      OutputOpelog('issue_detail', 'reference', "HEALTH_ARN#" + issueArn);
    }
  }, [issueArn,execFlag,getIssueDetail]);
  
  // エラーダイアログ表示後、本ダイアログも閉じる
  useEffect(() => {
    if( closeFlag ) setIssueArn('');
  }, [closeFlag]);
  
  return (
    <>
    {errObj && !closeFlag ? (
      <ErrorDialog errTitle={'取得エラー'} errObj={errObj} opeErrMes="" setCloseFlag={setCloseFlag} />
      
    ) : direct ? (
      <IssueDetailBase
        issueArn={issueArn}
        executing={executing}
        issueDetailObj={issueDetailObj}
      />
          
    ) : (
      <Modal
        isOpen={isOpen}
        onClose={()=>setIssueArn('')}
        motionPreset="slideInBottom"
        autoFocus={false}
        size={GV_DIALOG_SIZE}
        isCentered
        closeOnOverlayClick={false}
        scrollBehavior='inside'
        allowPinchZoom
      >
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalBody>
            <IssueDetailBase
              issueArn={issueArn}
              executing={executing}
              issueDetailObj={issueDetailObj}
            />
            
          </ModalBody>
          
          <ModalFooter>
            <PrimaryButton type='ok' onClick={()=>setIssueArn('')} isLoading={executing}>
              閉じる
            </PrimaryButton>
          </ModalFooter>
        </ModalContent>
      </Modal>
    )}
    </>
  );
});